import React, { Component } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";
import { connect } from "react-redux";

class LoadingCell extends Component {
  render() {
    const { language, cellHeight } = this.props;
    return (
      <Skeleton
        className="col-6"
        variant="rect"
        style={{
          borderRadius: 8,
          backgroundColor: "#c3c3c3",
          height: cellHeight,
          transform: "scale(0.91)",
        }}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(LoadingCell);
